import type { OpenNotificationParams } from '@/services/notification/models/notification';
import { duplicateInvoiceNotification } from './notifications/duplicate-invoice.notification';
import { fileTooLargeNotification } from './notifications/file-too-large.notification';
import { genericErrorNotification } from './notifications/generic-error.notification';
import type { NotificationMatcher } from './notifications/notification-matcher';
import { sharePointProjectNotFoundNotification } from './notifications/sharepoint-project-not-found.notification';
import { sharePointProvisioningBusyNotification } from './notifications/sharepoint-provisioning-busy.notification';

const NOTIFICATION_REGISTRY: NotificationMatcher[] = [
  duplicateInvoiceNotification,
  fileTooLargeNotification,
  sharePointProvisioningBusyNotification,
  sharePointProjectNotFoundNotification,
  genericErrorNotification,
];

export function findNotification(
  error: unknown,
): OpenNotificationParams | null {
  for (const match of NOTIFICATION_REGISTRY) {
    const result = match(error);
    if (result) return result;
  }
  return null;
}
